//服务费收取明细
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createForm } from 'rc-form';
import Util from '../../util.js';
import NHeader from "../NHeaderjiaoyijilu";
import { ztcgjiaoyijiluxiangqing} from '../../action/investmentAction';
import NavigatorMain from '../NavigatorMain';
import { Picker, List, WhiteSpace, ListView } from 'antd-mobile/lib';
import '../css/Transferrecord.css'
import { hashHistory } from "react-router";
class Servicechargerecord extends Component {  
  constructor(props) {  
    super(props); 
    this.state = {
      loadingFlag: false,
        xinxi:[]
    } 
  }

  goBack() {
    hashHistory.goBack();
  }
  componentDidMount(){
    let { dispatch } = this.props;
    let _this = this;
    let data1 = {
      tradeRequestId:this.props.location.state.tradeRequestId,
  }
      dispatch(ztcgjiaoyijiluxiangqing(data1,this.callbackData.bind(this),_this))
  }
  callbackData(data){
    console.log(data)
      this.setState({
        xinxi:data
      })
  }
  getNum=(num1,num2)=>{
    if(num1 === null && num2 === null){
      return null
    }else if(num1 === null){
      return num2 + '份'
    }else if(num2 === null){
      return num1 + '元'
    }else if(num1 == num2){
      return num1 + '元'
    }else{
      return null
    }
  }
  render() {
      let {xinxi}=this.state;
      console.log(xinxi)
      return (  
        <div className="container">  
            <div className="NHeader_container">
        <div className="NHeader_wrap">         
          <div className="NHeader_content">
            <div className="NHeader_goback" onClick={this.goBack}><img src={require('../../img/n_icon_goback@2x.png')} /></div>
            <div className="NHeader_title">交易详情</div>
            <div className="NHeader_share">
            </div>
          </div>
        </div>
        </div>
   
          <div className="jiaoyixiangqing"> 
          {xinxi.map((item ,index)=>{
              return (
                <div key={index} className="jiaouyixiangqingtopfuwufei">
                <div className="jiaouyixiangqingtop2">
                  <div className="jiaouyixiangqingtop2top">服务费金额</div>
                            <text style={{color:"#333333"}}>{item.confirmAmount ? Util.thousandCount(item.confirmAmount) + "元":"--"}</text>
                </div>
                <div className="jiaouyixiangqingtop2">
                  <div  className="jiaouyixiangqingtop2top">收费产品</div>
                  <div  className="jiaouyixiangqingtop2bottom">{item.fundName ? item.fundName:"--"}</div>
                </div>
                <div className="jiaouyixiangqingtop2">
                  <div  className="jiaouyixiangqingtop2top">收费时间</div>
                  <text style={{color:"#333333"}}>{item.confirmDateStr || '--'}</text>
                </div>
                <div className="jiaouyixiangqingtop2">
                  <div  className="jiaouyixiangqingtop2top">所属投顾产品</div>
                  <text style={{color:"#333333"}}>{item.targetFundName || '--' }</text>
                </div>
                <div className="jiaouyixiangqingtop2">
                  <div  className="jiaouyixiangqingtop2top">支付渠道</div>
                  <text style={{color:"#333333"}}>{item.trustChannelName || '--'}</text>
                  
                </div>
               </div>
               
              )
          })}
  
         </div>
        </div>
    
    )
  }  
}  
  
function mapStateToProps(state, ownProps) {
  return {
    shareToInfo:state.shareToInfo,
  }
}
export default connect(mapStateToProps)(Servicechargerecord);



// WEBPACK FOOTER //
// ./src/components/fundDetail/Servicechargerecord.js